import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Sources from '../components/Sources';
import FAQSection from '../components/FAQSection';
import Breadcrumbs from '../components/Breadcrumbs';

export default function Dictionary() {
  const breadcrumbs = [
    { name: "Forside", path: "/" },
    { name: "Ordbog", path: "/ordbog" }
  ];
  const terms = [
    {
      term: "Egenvægt",
      def: "Vægten af køretøjet (bil eller trailer) i køreklar stand uden passagerer, last eller gods, men typisk med fabriksmonteret grundudstyr.",
      link: "/trailer-totalvaegt",
      linkText: "Læs om egenvægt og totalvægt"
    },
    {
      term: "Tilladt totalvægt",
      def: "Den absolut maksimale vægt, som køretøjet lovligt må veje inklusive egenvægt, fører, passagerer og alt medbragt gods. Tallet fremgår af køretøjets registreringsattest og typeskilt.",
      link: "/trailer-totalvaegt",
      linkText: "Se regler for tilladt totalvægt"
    },
    {
      term: "Faktisk totalvægt",
      def: "Den reelle vægt af køretøjet og dets last i det præcise øjeblik, det befinder sig på vejen. Det er den vægt, politiet måler ved en vejkontrol med en vægt.",
      link: "/trailer-totalvaegt",
      linkText: "Forskellen på tilladt og faktisk vægt"
    },
    {
      term: "Lasteevne (nyttelast)",
      def: "Forskellen mellem den tilladte totalvægt og egenvægten. Lasteevnen angiver, hvor mange kilo gods og last du maksimalt må placere på traileren.",
      link: "/trailer-totalvaegt",
      linkText: "Sådan beregnes lasteevne"
    },
    {
      term: "Kugletryk (lodret tryk / S-værdi)",
      def: "Den lodrette vægt, som trailerens koblingshoved trykker ned på bilens anhængerkrog. For almindelige personbiler ligger det tilladte kugletryk typisk mellem 50 og 75-80 kg.",
      link: "/kugletryk",
      linkText: "Se alt om korrekt kugletryk"
    },
    {
      term: "Teknisk koblingsvægt",
      def: "Den maksimale vægt af et påhængskøretøj, som bilens fabrikant har godkendt bilen til at trække (med eller uden bremser). Angivet i bilens registreringsattest.",
      link: "/hvor-meget-maa-man-traekke",
      linkText: "Hvor meget må bilen trække?"
    },
    {
      term: "Samlet tilladt vogntogsvægt",
      def: "Summen af bilens tilladte totalvægt og trailerens tilladte totalvægt. Denne sum er afgørende for, hvilken kørekortkategori (B, B+ eller BE) der kræves.",
      link: "/koerekort-og-trailer",
      linkText: "Se kørekortgrænser for vogntog"
    },
    {
      term: "Kategori B+ (kode 96)",
      def: "En udvidelse af det almindelige personbilskørekort, som giver ret til at køre med et vogntog med en samlet tilladt totalvægt på op til 4.250 kg, selv når trailerens totalvægt overstiger 750 kg.",
      link: "/koerekort-og-trailer",
      linkText: "Forskellen på B+ og BE"
    },
    {
      term: "Kategori BE (stort trailerkort)",
      def: "Kørekortkategori der giver ret til at føre en person- eller varebil (op til 3.500 kg) med et påhængskøretøj på op til 3.500 kg tilladt totalvægt – samlet vogntog op til 7.000 kg.",
      link: "/be-koerekort",
      linkText: "Alt om BE-kørekort og prøve"
    },
    {
      term: "Tempo 100",
      def: "En særlig godkendelsesordning, der under bestemte tekniske betingelser (støddæmpere, dækalder, bremser, vægtforhold) tillader kørsel med op til 100 km/t med trailer på motorvej.",
      link: "/tempo-100",
      linkText: "Krav og godkendelse til Tempo 100"
    },
    {
      term: "Påløbsbremse",
      def: "Mekanisk bremsesystem på traileren, som automatisk aktiveres ved hjælp af en støddæmper og stangforbindelse i trækstangen, når trækbilen bremser og traileren skubber på.",
      link: "/trailer-bremser",
      linkText: "Regler for trailerbremser"
    },
    {
      term: "Sikkerhedswire (springwire)",
      def: "En tynd stålwire, der forbinder trailerens håndbremsemekanisme med bilens faste trækdel. Hvis traileren falder af trækket under kørsel, aktiverer wiren trailerens bremse.",
      link: "/trailer-bremser",
      linkText: "Korrekt montering af springwire"
    }
  ];

  const faq = [
    {
      q: "Hvad er den vigtigste forskel på tilladt totalvægt og faktisk totalvægt?",
      a: "Tilladt totalvægt er et fast tal på registreringsattesten, som afgør hvilken kørekortkategori du skal have. Faktisk totalvægt er, hvad vogntoget vejer på en vægt lige nu, og den må aldrig overstige hverken bilens godkendte trækvægt eller trailerens tilladte totalvægt."
    },
    {
      q: "Hvad sker der, hvis kugletrykket er for lavt?",
      a: "Et for lavt eller negativt kugletryk (hvor traileren er bagtung) løfter bilens baghjul op, hvilket skaber en voldsom ustabilitet og livsfarlig slinger i vogntoget ved almindelig landevejsfart."
    },
    {
      q: "Hvad dækker begrebet koblingsvægt over?",
      a: "Koblingsvægt er den maksimale vægt af en trailer, som din specifikke bil må trække ifølge bilens typegodkendelse og registreringsattest. Der skelnes mellem vægt med og uden bremser."
    }
  ];

  const sources = [
    { title: "Kørekortbekendtgørelsen (BEK nr. 1243 af 28/08/2020)", source: "retsinformation.dk", url: "https://www.retsinformation.dk/eli/lta/2020/1243" },
    { title: "Dimensionsbekendtgørelsen (BEK nr. 577 af 30/03/2021)", source: "retsinformation.dk", url: "https://www.retsinformation.dk/eli/lta/2021/577" },
    { title: "Bekendtgørelse om køretøjers indretning og udstyr (BEK nr. 154 af 28/01/2021)", source: "retsinformation.dk", url: "https://www.retsinformation.dk/eli/lta/2021/154" }
  ];

  return (
    <>
      <SEO 
        title="Ordbog over trailerbegreber — Vægt, kørekort og udstyr" 
        description="Definitioner på trailerbegreber: tilladt totalvægt, egenvægt, lasteevne, kugletryk, koblingsvægt, B+, BE og Tempo 100." 
        pathname="/ordbog"
        faq={faq}
        breadcrumbs={breadcrumbs}
      />

      <article>
        <Breadcrumbs items={breadcrumbs} />
        <h1 className="text-[30px] sm:text-[36px] font-bold text-[#2E3A46] tracking-tight leading-tight mb-4">
          Ordbog over trailerbegreber
        </h1>

        <p className="text-[18px] text-[#1A1C1F] leading-relaxed mb-6 font-medium">
          En samlet oversigt over de vigtigste tekniske og juridiske begreber inden for kørsel med trailer og påhængskøretøjer i Danmark.
        </p>

        <p className="text-[17px] text-[#1A1C1F] leading-relaxed mb-8">
          Når man læser færdselsregler, støder man ofte på begreber som tilladt totalvægt, faktisk vægt og kugletryk. Forskellen mellem disse betegnelser er afgørende for, om du kører lovligt med dit kørekort og din bil.
        </p>

        <div className="space-y-6">
          {terms.map((item, idx) => (
            <div key={idx} className="p-5 border border-[#E4E1D8] bg-[#FBFAF6] rounded-[4px]">
              <h2 className="text-[19px] font-bold text-[#2E3A46] mb-2 font-mono">
                {item.term}
              </h2>
              <p className="text-[16px] text-[#1A1C1F] leading-relaxed mb-3">
                {item.def}
              </p>
              <Link 
                to={item.link} 
                className="text-[14px] font-semibold text-[#B58200] hover:text-[#2E3A46] hover:underline underline-offset-2"
              >
                → {item.linkText}
              </Link>
            </div>
          ))}
        </div>

        <FAQSection items={faq} />
        <Sources links={sources} />
      </article>
    </>
  );
}
